import React from 'react';

// Avatar de reserva: twitchImage/youtubeImage tienen '' por defecto en muchos
// usuarios antiguos. Es el mismo placeholder que usa la busqueda publica.
const AVATAR_FALLBACK = 'https://i.ibb.co/SwJjK1T/16686.png';

export const getUserLabel = (u, platform) => {
  if (platform === 'youtube') {
    return (u.youtubeDisplayName || u.displayname || '') + (u.useryt ? ' (' + u.useryt + ')' : '');
  }
  return (u.displayname || '') + (u.usert ? ' (' + u.usert + ')' : '');
};

// Selector de usuario compartido por AdminOverbox y AdminReward (antes estaba
// duplicado literalmente en los dos). Ordena los resultados por presencia en el
// directo: EN DIRECTO -> HOY -> resto, ese orden lo decide el backend.
const AdminUserPicker = ({ platform, onPlatformChange, selectedUser, onSelectUser, showOverbox }) => {
  const [search, setSearch] = React.useState('');
  const [results, setResults] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [soloDirecto, setSoloDirecto] = React.useState(false);

  const doSearch = async () => {
    if (!search) {
      setResults([]);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const formData = new FormData();
      formData.append('search', search);
      const res = await fetch('/api/adminLogin?action=searchUser&platform=' + encodeURIComponent(platform), {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      setResults(Array.isArray(data) ? data : []);
    } catch (err) {
      setError('Error buscando usuarios');
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const enDirecto = results.filter(u => u.presence === 'live').length;
  // El filtro es en cliente: los del directo siempre entran en el corte del
  // backend, asi que no hace falta volver a consultar.
  const visibles = soloDirecto ? results.filter(u => u.presence === 'live') : results;

  const getAvatar = (u) => (platform === 'youtube' ? u.youtubeImage : u.twitchImage) || AVATAR_FALLBACK;

  return (
    <>
      <div className='formFieldRow'>
        <label className='formFieldLabel heroes'>Plataforma</label>
        <select
          className='userSearch'
          value={platform}
          onChange={(e) => {
            onPlatformChange(e.target.value);
            setResults([]);
            setSoloDirecto(false);
            setError('');
          }}
        >
          <option value='twitch'>Twitch</option>
          <option value='youtube'>YouTube</option>
        </select>
      </div>
      <div className='formFieldRow'>
        <label className='formFieldLabel heroes'>Buscar usuario</label>
        <input
          className='userSearch'
          placeholder={platform === 'youtube' ? 'YouTube display name o channel id' : 'Display name Twitch'}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { doSearch(); } }}
        />
      </div>
      <div className='navTops heroes unselectable'>
        <div onClick={doSearch}>Buscar</div>
      </div>

      {platform === 'twitch' && results.length > 0 ? (
        <div className='pickerFilterRow heroes'>
          <label className='pickerFilterLabel'>
            <input
              type='checkbox'
              checked={soloDirecto}
              onChange={(e) => setSoloDirecto(e.target.checked)}
            />
            Solo directo
          </label>
          <span className='pickerFilterCount'>En el directo: {enDirecto}</span>
        </div>
      ) : null}

      {platform === 'youtube' ? (
        <p className='pickerHint heroes'>YouTube no tiene lista de espectadores: busca por nombre.</p>
      ) : null}

      {loading ? <p>Cargando...</p> : null}
      {error ? <p role='alert' className='pickerHint heroes'>{error}</p> : null}

      {!loading && soloDirecto && results.length > 0 && visibles.length === 0 ? (
        <p className='pickerHint heroes'>Nadie de los resultados está en el directo ahora mismo.</p>
      ) : null}

      {visibles.length > 0 ? (
        <div className='userResults userResultsPicker'>
          {visibles.map(u => (
            <div
              key={u._id}
              className={'pickerRow' + (selectedUser && selectedUser._id === u._id ? ' pickerRowSel' : '')}
              onClick={() => onSelectUser(u)}
            >
              <img
                className='pickerAvatar'
                alt=''
                src={getAvatar(u)}
                onError={(e) => { e.currentTarget.src = AVATAR_FALLBACK; }}
              />
              <span className='pickerInfo'>
                <span className='pickerName'>{getUserLabel(u, platform)}</span>
                <span className='pickerMeta'>
                  {u.presence === 'live' ? <span className='presenceTag presenceLive'>EN DIRECTO</span> : null}
                  {u.presence === 'today' ? <span className='presenceTag presenceToday'>HOY</span> : null}
                  {showOverbox ? <span className='pickerOver'>Overbox: {u.overbox != null ? u.overbox : 0}</span> : null}
                </span>
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default AdminUserPicker;
